// extracted by mini-css-extract-plugin
export default {"loadingOverlayContainer":"Chats_loadingOverlayContainer__Wfgj6","header":"Chats_header__RMkxL"};